import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { applyTheme, themeByKey, DEFAULT_THEME } from "@/lib/themes";

const STORAGE_KEY = "sc-theme-v2";
const ThemeContext = createContext(null);

const read = (k, d) => { try { return localStorage.getItem(k) || d; } catch { return d; } };
const write = (k, v) => { try { localStorage.setItem(k, v); } catch (_e) { /* ignore */ } };

export function ThemeProvider({ children }) {
  const [themeKey, setThemeKey] = useState(() => themeByKey(read(STORAGE_KEY, DEFAULT_THEME)).key);

  useEffect(() => {
    const th = applyTheme(themeKey);
    write(STORAGE_KEY, th.key);
    write(`sc-theme-last-${th.mode}`, th.key);
  }, [themeKey]);

  const mode = themeByKey(themeKey).mode;
  const choose = useCallback((k) => {
    setThemeKey(k);
    api.patch("/auth/me/theme", { theme: k }).catch(() => {});
  }, []);
  const toggle = useCallback(() => {
    choose(mode === "light" ? read("sc-theme-last-dark", "macbook-dark") : read("sc-theme-last-light", DEFAULT_THEME));
  }, [mode, choose]);

  return (
    <ThemeContext.Provider value={{ theme: mode, themeKey, setThemeKey, choose, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used inside <ThemeProvider>");
  return ctx;
}
